import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { BOOKS_PREVIEW_SEARCH } from "./data/book_preview_search";
import * as _ from "lodash";
import { Img } from "../shared/img";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation, Autoplay, Keyboard, A11y } from "swiper";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useLanguage } from "../../hooks/use-language";
import { useTranslationsById } from "../../hooks/use-translations-by-id";

/**
 * Retorna el texto introductorio en libros y los filtros de busqueda
 * @param {object} texts contiene los textos de interfaz
 * @returns {JSX.Element} IntroHome
 */
export const FilterBooks = () => {

    const options = [...BOOKS_PREVIEW_SEARCH];
    const [currentOption, setCurrentOption] = useState();

    const lang = useLanguage();
    const txts = useTranslationsById({ mainSectionName: "libros", language: lang });

    const prevButtonBooksRef = useRef(null);
    const nextButtonBooksRef = useRef(null);

    const updateNavigation = (swiper) => {
        swiper.params.navigation.prevEl = prevButtonBooksRef?.current
        swiper.params.navigation.nextEl = nextButtonBooksRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200 ? true : false);

    //SET MOBILE
    useEffect(() => {
        const setMobile = () => {
            let validacion;
            if (window.innerWidth < 1200) {
                validacion = true;
            } else {
                validacion = false;
            }
            setIsMobile(validacion)
        }
        setMobile();
        window.addEventListener('resize', setMobile)
        return () => {
            window.removeEventListener('resize', setMobile)
        }
    }, [])


    return (
        <section className="container container-filter">
            <div className="d-flex flex-wrap">
                <div className="col-12 col-md-7">
                    <div className="h-100 d-flex align-items-center">
                        <div>
                            <h2 className="title4 secondary-font onprimary--color">
                                {txts?.getText({ id: "description1", defaultText: "MakeMake ofrece a tu colegio y biblioteca suscripciones anuales para el acceso a una cuidadora selección de libros en castellano para niños entre los 3 y 15 años elegidos de las mejores editoriales de América Latina." })}
                            </h2>
                            <p className="text-introduction my-3">
                                {txts?.getText({ id: "description2", defaultText: "En MakeMake encuentras novelas y cuentos cortos, cómics, libros álbum, poesía, libros informativos y libros interactivos." })}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-5 mt-3 mt-md-0">
                    <div>
                        <Img src="/img/matilda-libro.png" alt="" className="img-fluid" style={{ maxWidth: 250 }} />
                    </div>
                    <div className="wrapper-tags">
                        <section className="my-3 relative swiper-libros">
                            <div className="wrapper-swiper-filtes-books">
                                <Swiper
                                    keyboard={{ enabled: true }}
                                    className="swiper-filter-books libros-filter-books"
                                    spaceBetween={5}
                                    mousewheel={{
                                        forceToAxis: true,
                                    }}
                                    autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: false,
                                    }}
                                    navigation={{
                                        nextEl: nextButtonBooksRef?.current,
                                        prevEl: prevButtonBooksRef?.current,
                                    }}
                                    onSwiper={(swiper) => {
                                        updateNavigation(swiper);
                                    }}
                                    modules={[Navigation, Mousewheel, Autoplay, Keyboard, A11y]}
                                    slidesPerView={2}
                                    slidesPerGroup={2}
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 2,
                                            slidesPerGroup: 2,
                                        },
                                        400: {
                                            slidesPerView: 3,
                                            slidesPerGroup: 3,
                                        },
                                        617: {
                                            slidesPerView: 4,
                                            slidesPerGroup: 4,
                                        },
                                        768: {
                                            slidesPerView: 1,
                                            slidesPerGroup: 1,
                                        },
                                        992: {
                                            slidesPerView: 2,
                                            slidesPerGroup: 2,
                                        },
                                        1500: {
                                            slidesPerView: 3,
                                            slidesPerGroup: 3,
                                        }
                                    }}
                                    a11y={{
                                        containerMessage: txts.getText({ id: "categorias.containerMessage", defaultText: "categorías de libros" }),
                                        itemRoleDescriptionMessage: txts.getText({ id: "categorias.containerMessage", defaultText: "categorías de libros" }),
                                    }}
                                >
                                    {options.map((option, i) => {
                                        return (
                                            <SwiperSlide
                                                key={`other${i}`}
                                                className="focusable-by-children-secondary p-0"
                                            >
                                                <Link
                                                    to={option?.type === "gratis" ? `/coleccion/libros-gratuitos/` : `/busqueda?${option?.type}=${option?.value}`}
                                                    onClick={() => { setCurrentOption(option) }}
                                                    style={{ fontWeight: 500 }}
                                                    className={`p-2 px-3 preview-option-books focusable-red ${currentOption?.value === option?.value ? "selected" : ""
                                                        }`}

                                                >
                                                    {txts?.getText({
                                                        id: option?.text?.translationPath,
                                                        defaultText: option?.text?.default
                                                    })

                                                    }
                                                </Link>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                                <div className="button-swiper filter-books d-none d-md-block">
                                    <div className="buttons d-flex justify-content-center justify-content-md-between mt-3 mt-lg-0 px-0">
                                        <button ref={prevButtonBooksRef} aria-label="previous" aria-hidden={true} className="home-swiper-navigation-buttons mr-3 mr-md-0 ">
                                            <Icon className="icon" icon="material-symbols:arrow-back-rounded" width={20} />
                                        </button>
                                        <button ref={nextButtonBooksRef} aria-label="next" aria-hidden={true}className="home-swiper-navigation-buttons ">
                                            <Icon className="icon" icon="material-symbols:arrow-forward-rounded" width={20} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section >
    )
}